import { LocationDictionaryModel } from '@/lib/models/location/types';
import { IdentifierApiInterface } from '@/types/api-types';
import { getPreferredIdentifier } from '@/utils/helpers';

export const getLocationPreferredIdentifiers = ({
  locationIds,
  locations,
}: {
  locationIds: string[];
  locations: LocationDictionaryModel;
}): IdentifierApiInterface[] => {
  return locationIds
    .map((locationId) => {
      const location = locations[locationId];
      return getPreferredIdentifier(location?.identifiers);
    })
    .filter((identifier): identifier is IdentifierApiInterface => Boolean(identifier));
};
